import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import GenericEntityCreator from '../../components/Common/GenericEntityCreator';

const CreateBot: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = (bot: any) => {
    console.log('Bot created successfully:', bot);
    // Navigate to bot details page
    navigate(`/bots/${bot.id}`);
  };

  const handleCancel = () => {
    navigate('/bots');
  };

  return (
    <Box>
      {/* Breadcrumbs */}
      <Breadcrumbs separator={<NavigateNext fontSize="small" />} sx={{ mb: 3 }}>
        <Link
          component="button"
          variant="body1"
          onClick={() => navigate('/bots')}
          sx={{ textDecoration: 'none', color: 'text.primary', cursor: 'pointer' }}
        >
          Bot Management
        </Link>
        <Typography color="text.primary">Create Bot</Typography>
      </Breadcrumbs>

      {/* Page Title */}
      <Typography variant="h4" gutterBottom>
        Create New Bot
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Configure and create a new trading bot
      </Typography>

      {/* Entity Creator */}
      <GenericEntityCreator
        entityType="bot"
        onSuccess={handleSuccess}
        onCancel={handleCancel}
        redirectRoute="/bots"
      />
    </Box>
  );
};

export default CreateBot;

